<div class="row">
  <customer-form
    [processing]="processing"
    [languages]="languages"
    [countries]="countries"
    [localEntities]="localEntities"
    (toggleCreateCustomer)="create($event)"
    (toggleCancel)="cancel()"
  ></customer-form>
</div>
